var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{staticClass:"form-content pl-5 pr-5 altura-componente-container"},[_c('paciente-ficha-dados-gerais',{staticClass:"mt-5"}),_c('paciente-ficha-medica',{staticClass:"mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }